import { FaWhatsapp } from "react-icons/fa";
import { motion, AnimatePresence, useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";
import { BRAND, PRICING } from "@/lib/config";

export default function StickyCTA({ onBuyNow }) {
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    // Show once the user scrolls past the hero CTA area.
    // Hero CTAs sit within ~first viewport height; reveal after ~85vh scrolled.
    const threshold =
      typeof window !== "undefined" ? window.innerHeight * 0.85 : 700;
    setVisible(latest > threshold);
  });

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="mobile-sticky-cta"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-cream/90 backdrop-blur-xl border-t border-ink/15 px-4 py-3"
          data-testid="mobile-sticky-cta"
        >
          <div className="flex items-center gap-2">
            <button
              onClick={onBuyNow}
              className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-terracotta text-cream px-4 py-3 text-sm font-semibold hover:bg-terracotta-hover transition-colors"
              data-testid="mobile-buy-now-btn"
            >
              Buy now · {PRICING.currency}
              {PRICING.launch}
            </button>
            <a
              href={BRAND.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-full border border-ink/25 w-12 h-12 hover:bg-ink hover:text-cream transition-colors"
              data-testid="mobile-whatsapp-btn"
              aria-label="Chat on WhatsApp"
            >
              <FaWhatsapp className="text-whatsapp text-xl" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
